import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

// Get Leave Type
export const getLeaveType = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.LEAVE_TYPE,
    params
  );
  console.log(
    "🚀 ~ file: EdetailingRepository.ts ~ line 20 ~ fetchPlaylisttype ~ response",
    response.data
  );
  return response?.data;
};

// Add Leave Type
export const addLeaveTypes = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.LEAVE.ADD_LEAVE_TYPE, body);
};

//Update Leave Type
export const updateLeaveType = async (id: number, body: any) => {
  console.log(`id--------->${id}-------->body:${JSON.stringify(body)}`);
  return axiosInstance.put(
    `${API_ENDPOINTS.LEAVE.UPDATE_LEAVE_TYPE}/${id}`,
    body
  );
};

// Get Leave Configuration
export const getAllLeaveConfiguration = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.GET_ALL_LEAVE_CONFIGURATION,
    { params: params }
  );
  console.log(
    "🚀 ~ getAllLeaveConfiguration ~line 35 ~ fetchPlaylisttype ~  response:",
    response.data
  );

  return response?.data;
};

export const addLeaveConfiguration = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.LEAVE.ADD_LEAVE_CONFIGURATION, body);
};

export const updateLeaveConfiguration = async (id: number, body: any) => {
  console.log(
    `id Leave Config--------->${id}-------->body Leave Config:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.put(
    `${API_ENDPOINTS.LEAVE.UPDATE_LEAVE_CONFIGURATION}/${id}`,
    body
  );
};

// Get Leave Configuration
export const getAllLeaveRequestsData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.GET_ALL_LEAVE_REQUESTS,
    { params: params }
  );

  console.log(
    "🚀 ~ LeaveRepository.ts:70 ~ getAllLeaveRequestsData ~ response?.data:",
    response?.data
  );
  return response?.data;
};

// Get Leave View
export const getLeaveViewData = async (
  id: any,
  params: Record<string, any>
) => {
  console.log("🚀 ~ LeaveRepository.ts:80 ~ getLeaveView ~ id:", id);

  const response = await axiosInstance.get(
    `${API_ENDPOINTS.LEAVE.GET_ALL_LEAVE_VIEW}/${id}`,
    { params: params }
  );

  console.log(
    "🚀 ~ LeaveRepository.ts:83 ~ getLeaveView ~ response:",
    response
  );

  return response?.data;
};

// Update Leave Status
export const updateLeaveStatus = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.LEAVE.UPDATE_STATUS, body);
};

//UPDATE_LEAVE_REQUESTS

export const updateLeaveRequests = async (id: number, body: any) => {
  console.log(
    `id Leave Requests--------->${id}-------->body Leave Requests:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.put(
    `${API_ENDPOINTS.LEAVE.UPDATE_LEAVE_REQUESTS}/${id}`,
    body
  );
};

//GET_LEAVE_VIEW_STATUS

export const getAllLeaveViewStatus = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.GET_LEAVE_VIEW_STATUS,
    params
  );

  console.log(
    "🚀 ~ LeaveRepository.ts:124 ~ getAllLeaveViewStatus ~ response:",
    response
  );

  return response?.data;
};

export const getAllLeaveStatus = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.GET_LEAVE_STATUS,
    params
  );

  console.log(
    "🚀 ~ LeaveRepository.ts:138 ~ getAllLeaveStatus ~ response:",
    response
  );

  return response?.data;
};

export const getAllLeaveBalance = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.LEAVE.GET_LEAVE_BALANCE,
    { params: params }
  );

  console.log(
    "🚀 ~ LeaveRepository.ts:152 ~ getAllLeaveBalance ~ response:",
    response
  );

  return response?.data;
};

export const getPolicyYear = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.LEAVE.GET_POLICY_YEAR);

  console.log(
    "🚀 ~ LeaveRepository.ts:163 ~ getPolicyYear ~ response:",
    response
  );

  return response?.data;
};
